<template>
    <div>
      <PictureList :dataLink="dataLink"></PictureList>
    </div>
</template>
 
<script>
import PictureList from  './PictureList' //学习园地的图片列表组件
export default {
    components:{
      PictureList
    },
    data(){
        return{
          dataLink:"",
        }
    },
    created(){
      var allcanshu=[];
      this.dataLink="";
      for (var x in this.$route.query){
          if(x=="datalink"){
              allcanshu.push(this.$route.query[x]);
          }else{
              allcanshu.push(x+'='+this.$route.query[x]);
          } 
      }
      this.dataLink = allcanshu.join("&");
    }
}
</script>

<style>
</style>